import { render } from "./platform_switcher.html?vue&type=template&id=1dc992fb&external"
import script from "./platform_switcher.js?vue&type=script&lang=js&external"
export * from "./platform_switcher.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__